/**
 * Actions Related to top level Application Navigation
 *
 */
export const NAVIGATE_TO_EB = 'NAVIGATE_TO_EB';
export function navigateToEB() {
  return {
    type: NAVIGATE_TO_EB,
  };
}

export const NAVIGATE_TO_PC = 'NAVIGATE_TO_PC';
export function navigateToPC() {
  return {
    type: NAVIGATE_TO_PC,
  };
}

export const NAVIGATE_TO_EB_BROKER_SEARCH = 'NAVIGATE_TO_EB_BROKER_SEARCH';
export function navigateToEBBrokerSearch() {
  return {
    type: NAVIGATE_TO_EB_BROKER_SEARCH,
  };
}
